export class LongPressGesture {
  private startedAt: number | null = null
  private triggered = false

  constructor(private readonly durationMs: number) {}

  start(now: number): void {
    this.startedAt = now
    this.triggered = false
  }

  cancel(): void {
    this.startedAt = null
    this.triggered = false
  }

  consume(now: number): boolean {
    if (this.startedAt === null || this.triggered) return false
    if (now - this.startedAt < this.durationMs) return false

    this.triggered = true
    return true
  }
}
